import React, { Component } from 'react';
import { MODELS } from '../../../constants/admin/settings';
import AdminTable from '../AdminTable';
import CategoryConfigRow from '../../../components/tables/CategoryConfigRow';
import CategoryPreview from '../../../components/admin/CategoryPreview';

class CategoriesOverview extends Component {
    render() {
        const { tableData, categoryConfig, onOpenCategory, onAddCategory, onBulkDeleteCategories, onPositionChange } =
            this.props;
        const categories = categoryConfig?.categories || [];

        return (
            <>
                <CategoryPreview categories={categories} mode="overview" />
                <AdminTable
                    model={MODELS.EVENT_CLEARANCE_CATEGORY}
                    data={tableData}
                    rowComponent={CategoryConfigRow}
                    openItem={onOpenCategory}
                    buttonAction={onAddCategory}
                    deleteAction={onBulkDeleteCategories}
                    enableSearch={true}
                    canOpenRows={true}
                    pagination={false}
                    scroll={true}
                    tableIndex={2}
                    rowProps={{ onPositionChange }}
                />
            </>
        );
    }
}

export default CategoriesOverview;
